const faqs = [
  {
    question: "Does Oklahoma have its own regional passport agency?",
    answer: "No — Oklahoma does not have a regional passport agency. The nearest agencies are the Dallas Passport Agency (about 3.5 hours from Oklahoma City via I-35) and the Houston Passport Agency (about 5.5 hours). Using a registered courier like Fast Passport Center is typically faster and more convenient for most Oklahoma residents.",
  },
  {
    question: "How fast can I get a passport in Oklahoma?",
    answer: "With Fast Passport Center's courier service, Oklahoma travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Oklahoma?",
    answer: "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility — typically a post office, county clerk, or public library. Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which airport should I fly from for international travel from Oklahoma?",
    answer: "Will Rogers World Airport (OKC) and Tulsa International (TUL) offer direct connections to major hubs. For broader international options, many Oklahoma travelers drive to Dallas-Fort Worth (DFW), about 3.5 hours south, which has extensive non-stop international routes.",
  },
  {
    question: "I am a student at OU or OSU — how do I get a passport for study abroad?",
    answer: "As a student, you will need to apply for a standard civilian passport. Both the University of Oklahoma (Norman) and Oklahoma State University (Stillwater) have post offices and county clerk offices nearby that serve as acceptance facilities. Using a courier service is the fastest way to get your passport before your study abroad program begins.",
  },
  {
    question: "Where is the best place to get a passport photo in Oklahoma?",
    answer: "CVS, Walgreens, UPS Store, FedEx Office, and Walmart locations across Oklahoma offer passport photo services. Most offer walk-in service. Always verify the photo meets State Department requirements (2×2 inches, white background, taken within 6 months) before submitting.",
  },
];

export { faqs };

export default function OKFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Oklahoma Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Oklahoma.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-white rounded-lg border border-gray-200 overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}